'use client';

import Image from 'next/image';

import { cn } from '@kit/ui/utils';

// Brand icons used in the aXcelerate marketing page flowcharts. Kept
// separate from the flow engine so the engine stays product-agnostic.

export function AxcelerateBrandIcon({ className }: { className?: string }) {
  return (
    <Image
      src="/images/partners/axcelerate-icon.svg"
      alt=""
      width={161}
      height={147}
      className={cn('h-full w-full object-contain', className)}
    />
  );
}

export function LeagenBrandIcon({ className }: { className?: string }) {
  return (
    <svg
      viewBox="0 0 124.01 135.57"
      xmlns="http://www.w3.org/2000/svg"
      className={cn('h-full w-full', className)}
    >
      <path
        fill="none"
        stroke="currentColor"
        strokeWidth={10}
        d="M81.04,8.28C51.42-2.22,18.78,13.34,8.28,42.96c-4.6,12.98-4.35,27.18.71,39.97,4.64,11.74,13.02,21.59,23.77,28-.64,2.22-1.79,5.7-2.83,8.66l-2.78,7.84,7.86-2.73c.12-.04,11.09-3.85,18.03-6.41,12.82,2.05,26.05-.37,37.38-6.88,11.78-6.77,20.77-17.55,25.32-30.38,10.5-29.62-5.06-62.27-34.68-72.77h0Z"
      />
      <path
        fill="currentColor"
        d="M78.68,50.62c3.16,0,12.06.52,12.06,11.52,0,12.15-8.95,14.71-13.43,15.35-2.38.34-9.26.89-16.44.89-6.34,0-12.92-.43-16.82-1.8-8.31-2.92-10.23-8.68-10.23-14.43s3.84-11.51,10.23-11.51h33.84c.19,0,.46,0,.79,0M78.68,42.48h0c-.22,0-.42,0-.59,0h-.19s-33.84,0-33.84,0c-10.3,0-18.37,8.63-18.37,19.64,0,13.72,8.52,19.59,15.67,22.11,4.32,1.52,10.7,2.26,19.52,2.26,7.46,0,14.77-.57,17.58-.97,12.78-1.83,20.41-10.57,20.41-23.4,0-11.94-7.92-19.65-20.19-19.65h0Z"
      />
    </svg>
  );
}

// Destination card preset for the aXcelerate marketing page. Pass this as
// the `destination` render prop to FlowChart.
import { DestinationPanel } from './flow/nodes';

export function AxcelerateDestination() {
  return (
    <DestinationPanel
      darkImageSrc="/images/partners/axcelerate-logo-dark.svg"
      lightImageSrc="/images/partners/axcelerate-logo-light.svg"
      imageWidth={147}
      imageHeight={24}
      imageHeightClass="h-5"
      subtitle="Student Management System"
      fallbackLabel="aXcelerate"
    />
  );
}
